import React from 'react';
import Rider from '../Rider/Rider';
import './Home.css';
import BackPic from '../../images/background.png';
import BikePic from '../../images/bike.png';
import CarPic from '../../images/car.png';
import BusPic from '../../images/bus.png';
import TrainPic from '../../images/train.png';
import { Col, Container, Row } from 'react-bootstrap';

const Home = () => {
    
    const riders = [
        {
            title: 'Bike',
            imgUrl: BikePic,
            riderType: 'bike'
        },
        {
            title: 'Car',
            imgUrl: CarPic,
            riderType: 'car'
        },
        {
            title: 'Bus',
            imgUrl: BusPic,
            riderType: 'bus'
        },
        {
            title: 'Train',
            imgUrl: TrainPic,
            riderType: 'train'
        }
    ]

    return (
        <div className="container row m-5 justify-content-center">
            {
                riders.map(rider=><Rider key={rider.riderType} rider={rider}></Rider>)
            }
        </div>

        
        
    );
};

export default Home;